import product from './product.js';

export default (cart) => ({
	event: 'checkout',
	pageName: cart.page.tracking,
	ecommerce: {
		currencyCode: cart.order.currency,
		checkout: {
			products: cart.order.products.map(product), // Create an array of products
			actionField: {
				step: cart.page.number
			}
		}
	},
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
